//@flow
import {type StoreState} from '$src/state/types'
import {type AuthNamespaceState} from '$src/auth/types'

export function selectIdToken(state: StoreState): ?string {
  // $FlowIgnore
  return state.auth.tokensState.idToken
}

export function selectIdTokenFromLocalStorage(): ?string {
  const stringifiedAuthState = localStorage.getItem('frank-auth')
  if (!!stringifiedAuthState) {
    const authState: AuthNamespaceState = JSON.parse(stringifiedAuthState)
    if (typeof authState === 'object') {
      // $FlowIgnore
      return authState.tokensState && authState.tokensState.idToken
    }
  }
}

export function selectRefreshToken(state: StoreState): ?string {
  // $FlowIgnore
  return state.auth.tokensState.refreshToken
}

export function selectEmail(state: StoreState): ?string {
  // $FlowIgnore
  return state.auth.tokensState.email
}



// WEBPACK FOOTER //
// ./src/auth/selectors.js